import { useAppSelector } from '@store';
import {
  ButtonPseudo,
  ChangeLogs,
  PermissionDenied,
  PermissionEnum,
  Popup,
  SidePanel,
  SidePanelType,
  Textarea,
} from '@ui/src';
import TopUpPanel from '../../../common/top-up-panel';
import { OverviewPanelsTypes } from '../types';

import commonStyles from '../../../common/common.module.css';

const OverviewPanels = ({
  topUpPanelIsOpen,
  setTopUpPanelIsOpen,
  selectedTopUpId,
  setSelectedTopUpId,
  reopenPopupState,
  setReopenPopupVisible,
  setReopenPopupState,
  setReopenError,
  reopenInProgress,
  reopenPopupVisible,
  reopenReason,
  onReopenOrganization,
  reopenError,
  setReopenReason,
  changeLogsPanelIsOpen,
  setChangeLogPanelIsOpen,
  customerId,
  changeLogsIsLoading,
  changeLogs,
  changeLogsPagination,
  changeLogsIsFetching,
  getChangeLogsAction,
}: OverviewPanelsTypes) => {
  const { baseInformation } = useAppSelector(
    (state) => state.corporateCustomers.info.general,
  );
  const { activePermissions } = useAppSelector((state) => state.root);
  const { users } = useAppSelector((state) => state.administrationDictionaries);

  return (
    <>
      <TopUpPanel
        topUpPanelIsOpen={topUpPanelIsOpen}
        setTopUpPanelIsOpen={setTopUpPanelIsOpen}
        selectedTopUpId={selectedTopUpId}
        setSelectedTopUpId={setSelectedTopUpId}
        userAccounts={baseInformation?.accounts?.map((item) => ({
          accountId: item.id,
          account: { fullNumber: item.fullNumber },
          description: item.description,
        }))}
      />

      <Popup
        title={
          reopenPopupState === 'warning'
            ? 'Reopen organization'
            : 'State the reason for reopening'
        }
        description={
          reopenPopupState === 'warning'
            ? 'The organization will become available again'
            : ''
        }
        onCancelClick={() => {
          setReopenPopupVisible(false);
          setReopenPopupState('warning');
          setReopenError('');
        }}
        okButtonText={reopenInProgress ? 'Loading...' : 'Reopen organization'}
        cancelButtonText="Cancel"
        isVisible={reopenPopupVisible}
        isLoading={reopenInProgress}
        okButtonDisabled={
          Boolean(reopenPopupState === 'comment' && !reopenReason) ||
          reopenInProgress
        }
        onOkClick={() => {
          if (reopenPopupState === 'warning') {
            setReopenPopupState('comment');
          } else if (reopenPopupState === 'comment') {
            onReopenOrganization();
          }
        }}
      >
        <div>
          {reopenPopupState === 'comment' && (
            <>
              {reopenError && (
                <div className={commonStyles.reopenError}>{reopenError}</div>
              )}
              <Textarea
                name="reopenReason"
                value={reopenReason}
                onChange={(e) => setReopenReason(e.target.value)}
                placeholder="Reason"
                labelClassName={commonStyles.reopenReason}
              />
            </>
          )}
        </div>
      </Popup>
      <SidePanel
        isOpen={changeLogsPanelIsOpen}
        onClose={() => {
          setChangeLogPanelIsOpen(false);
        }}
        title="Customer change logs"
        type={SidePanelType.Accounts}
        sidepanelExpandedKey="customers-change-logs"
        footer={
          <div>
            <ButtonPseudo
              text="Close"
              onClick={() => setChangeLogPanelIsOpen(false)}
              bold
            />
          </div>
        }
        closeOnClickOutside
      >
        <>
          {activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
            <ChangeLogs
              entityType="ORGANIZATION"
              entityId={customerId as string}
              changeLogsIsLoading={changeLogsIsLoading}
              changeLogs={changeLogs}
              activePermission={activePermissions}
              users={users}
              pagination={changeLogsPagination}
              changeLogsIsFetching={changeLogsIsFetching}
              getChangeLogs={getChangeLogsAction}
            />
          )}
          {!activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
            <PermissionDenied />
          )}
        </>
      </SidePanel>
    </>
  );
};

export default OverviewPanels;
